import { flattenValues } from "@uniformdev/canvas";
import { UniformBlogNewsCardProps } from "src/uniform/contenttypes/blogNewsCard";
import { UniformEventCardProps } from "src/uniform/contenttypes/eventCard";

import {
    GalleryContainer,
    BlogEventCard,
    BlogNewsCard
} from "@/libraries/design/components";

export interface UniformBlogNewsGalleryProps {
    cards: (UniformBlogNewsCardProps | UniformEventCardProps)[];
    isMotionAvailable?: boolean;
}

const UniformBlogNewsGallery = ({
    cards,
    isMotionAvailable
}: UniformBlogNewsGalleryProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = flattenValues(cards as any) as (
        | UniformBlogNewsCardProps
        | UniformEventCardProps
    )[];
    return (
        <GalleryContainer isMotionAvailable={isMotionAvailable}>
            {flattenedCards.map((card, index) => {
                if (card) {
                    if ("dates" in card) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-ignore
                                    "--gc-item-i": index
                                }}
                            >
                                <BlogEventCard
                                    date={card.dates}
                                    location={card.location}
                                    title={card.title}
                                    link={{
                                        href: card.ctaUrl,
                                        text: card.ctaText
                                    }}
                                    image={{
                                        src: card.imageUrl,
                                        alt: card.imageAlt ?? ""
                                    }}
                                />
                            </div>
                        );
                    } else {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-ignore
                                    "--gc-item-i": index
                                }}
                            >
                                <BlogNewsCard
                                    color={card.color}
                                    label={card.label}
                                    title={card.title}
                                    link={{
                                        href: card.ctaUrl,
                                        text: card.ctaText
                                    }}
                                    image={{
                                        src: card.imageUrl,
                                        alt: card.imageAlt ?? ""
                                    }}
                                />
                            </div>
                        );
                    }
                }
            })}
        </GalleryContainer>
    );
};

export default UniformBlogNewsGallery;
